import { path } from 'ramda'

const MODAL_PATH = ['modal']

export const modalSelector = path(MODAL_PATH)
